import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

var _excluded = ["id"];
var DOLBY_DIGITAL_REPRESENTATION_CODECS = new Set(['ec-3', 'ac-3']);
var CLOSED_CAPTIONS = ' [CC]';
var KNOWN_LANGUAGES = new Set(['es', 'pt', 'en']);
var UNKNOWN_LANGUAGE_ORDER = 1000;
var TrackLanguageOrder = {
  BR: {
    pt: 1,
    en: 2,
    es: 3
  },
  SSLA: {
    es: 1,
    en: 2,
    pt: 3
  }
};
var TrackKind = {
  CAPTIONS: new Set(['caption', 'captions']),
  SUBTITLE: new Set(['subtitle'])
};
var DescriptiveAudio = {
  qad: {
    lang: 'qad',
    iso: 'pt',
    name: 'Portuguese',
    isDescriptive: true
  },
  qae: {
    lang: 'qae',
    iso: 'es',
    name: 'Spanish',
    isDescriptive: true
  },
  qaf: {
    lang: 'qaf',
    iso: 'en',
    name: 'English',
    isDescriptive: true
  }
};
function parseAudioTracks(tracks) {
  return tracks === null || tracks === void 0 ? void 0 : tracks.map(function (track) {
    var _track$getQualities = track.getQualities(),
      _track$getQualities2 = _slicedToArray(_track$getQualities, 1),
      _track$getQualities2$ = _track$getQualities2[0];
      _track$getQualities2$.id;
      var quality = _objectWithoutProperties(_track$getQualities2$, _excluded);
    var descriptiveInfo = DescriptiveAudio[track.lang];
    return _objectSpread(_objectSpread(_objectSpread({}, track), {}, {
      quality: quality
    }, descriptiveInfo), {}, {
      isDolby: DOLBY_DIGITAL_REPRESENTATION_CODECS.has(quality.codec),
      isAudio: true
    });
  });
}
function sortAudioTracks(orderByIso) {
  var compareByIso = tracksComparatorByIso(orderByIso);
  return function (tracks) {
    return tracks === null || tracks === void 0 ? void 0 : tracks.sort(function (trackA, trackB) {
      var isoComparison = compareByIso(trackA, trackB);
      if (isoComparison !== 0) return isoComparison;
      if (!trackA.isDescriptive && trackB.isDescriptive) {
        return -1;
      }
      if (trackA.isDescriptive && !trackB.isDescriptive) {
        return 1;
      }
      if (!trackA.isDolby && trackB.isDolby) {
        return -1;
      }
      if (trackA.isDolby && !trackB.isDolby) {
        return 1;
      }
      return 0;
    });
  };
}
function tracksComparatorByIso(orderByIso) {
  return function (trackA, trackB) {
    var orderA = orderByIso[trackA.iso] || UNKNOWN_LANGUAGE_ORDER + (trackA.unknownIndex || 0);
    var orderB = orderByIso[trackB.iso] || UNKNOWN_LANGUAGE_ORDER + (trackA.unknownIndex || 0);
    return orderA - orderB;
  };
}
function isLanguageUnknown(track) {
  return !KNOWN_LANGUAGES.has(track.iso);
}
function addIndexToUnknownTracks(tracks) {
  var unknownCount = 0;
  return tracks === null || tracks === void 0 ? void 0 : tracks.map(function (track) {
    if (!isLanguageUnknown(track)) return track;
    unknownCount += 1;
    return _objectSpread(_objectSpread({}, track), {}, {
      isUnknow: true,
      unknownIndex: unknownCount
    });
  });
}
function sortTextTracks(orderByIso) {
  var compareByIso = tracksComparatorByIso(orderByIso);
  return function (tracks) {
    return tracks === null || tracks === void 0 ? void 0 : tracks.sort(function (trackA, trackB) {
      var isoComparison = compareByIso(trackA, trackB);
      if (isoComparison !== 0) return isoComparison;
      if (!trackA.isClosedCaption && trackB.isClosedCaption) {
        return -1;
      }
      if (trackA.isClosedCaption && !trackB.isClosedCaption) {
        return 1;
      }
      return 0;
    });
  };
}
function parseTextTracks(tracks) {
  return tracks === null || tracks === void 0 ? void 0 : tracks.map(function (track) {
    return _objectSpread(_objectSpread({}, track), {}, {
      isClosedCaption: TrackKind.CAPTIONS.has(track === null || track === void 0 ? void 0 : track.kind),
      isText: true
    });
  });
}

var tracks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CLOSED_CAPTIONS: CLOSED_CAPTIONS,
  DOLBY_DIGITAL_REPRESENTATION_CODECS: DOLBY_DIGITAL_REPRESENTATION_CODECS,
  DescriptiveAudio: DescriptiveAudio,
  KNOWN_LANGUAGES: KNOWN_LANGUAGES,
  TrackKind: TrackKind,
  TrackLanguageOrder: TrackLanguageOrder,
  UNKNOWN_LANGUAGE_ORDER: UNKNOWN_LANGUAGE_ORDER,
  addIndexToUnknownTracks: addIndexToUnknownTracks,
  isLanguageUnknown: isLanguageUnknown,
  parseAudioTracks: parseAudioTracks,
  parseTextTracks: parseTextTracks,
  sortAudioTracks: sortAudioTracks,
  sortTextTracks: sortTextTracks,
  tracksComparatorByIso: tracksComparatorByIso
});

export { CLOSED_CAPTIONS as C, DOLBY_DIGITAL_REPRESENTATION_CODECS as D, KNOWN_LANGUAGES as K, TrackLanguageOrder as T, UNKNOWN_LANGUAGE_ORDER as U, TrackKind as a, DescriptiveAudio as b, tracksComparatorByIso as c, addIndexToUnknownTracks as d, sortTextTracks as e, parseTextTracks as f, isLanguageUnknown as i, parseAudioTracks as p, sortAudioTracks as s, tracks as t };
//# sourceMappingURL=tracks-b344ec6e.js.map
